import * as React from "react";
import {Form, Input, Row, Col, Switch} from "antd";
import {FormattedMessage} from "react-intl";
import {createRequest, updateRequest, fetchItemRequest} from "@actions/menu";
import {Menu} from "@models/menu";
import {SelectionMode} from "@models/index";
import MenuSingleSelection from "@components/menus/selection/MenuSingleSelection";
import menuApi from "@api/menu";
import withFormWrapper from "@hocs/withFormWrapper";
import {Select} from 'antd';
import {AppRoutes} from "../../App";

const Option = Select.Option;

interface PropsFromState {
  loading: boolean;
  errors?: string;
  form: any;
  menu?: Menu;
  is_active: boolean; // omit
}

interface PropsFromDispatch {
  createRequest: typeof createRequest;
  updateRequest: typeof updateRequest;
  fetchItemRequest: typeof fetchItemRequest;
}

type MenuFormStateShape = {
  visible: boolean;
  title: string;
  is_active: boolean;
  parent_id: string;
  url: string;
  id: string;
  parent: any;
};

type MenuFormAllProps = PropsFromState & PropsFromDispatch;

class MenuForm extends React.Component<MenuFormAllProps, MenuFormStateShape> {
  // private menus: MenuSingleSelectionReturnValue = menuSingleSelectionDefaultReturnValue;
  
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      // is_active:false,
      ...this.getStateFromProps(props.menu)
    };
  }
  
  getStateFromProps = (menu: Menu | null = {}) => {
    const obj = menu || {};
    return {
      title: obj.title || "",
      url: obj.url || "",
      id: obj.id,
      is_active: obj.is_active || false,
      parent_id: obj.parent ? obj.parent.id : obj.parent_id,
      parent: obj.parent || null
    };
  };
  
  fetchItem = () => {
    menuApi
      .getItem({
        params: {
          id: this.state.id
        }
      })
      .then(({data}) => {
        const obj = this.getStateFromProps(data);
        this.setState(obj);
      })
      .catch(error => console.log(error));
  };
  
  /**
   * Set cover and avatar ids in a form values to handle validation by form
   */
  getValues = () => {
    let returnValues: any = null;
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        let {title, url, parent} = values;
        returnValues = {
          title,
          url,
          is_active: this.state.is_active,
          parent_id: this.state.parent_id || parent ? parent.id : null
        };
      }
    });
    
    return {
      payload: returnValues,
      id: this.state.id
    };
  };
  
  onChangeParent = (menu: Menu): void => {
    this.setState({
      parent: menu,
      parent_id: menu.id
    });
  };
  
  onStatusChange(is_active: boolean) {
    this.setState({
      is_active
    });
  }
  
  render() {
    const {getFieldDecorator} = this.props.form;
    return (
      <Form>
        <Row gutter={24}>
          <Col span={9}>
            <Form.Item
              label={
                <FormattedMessage id="app.title" defaultMessage={`Title`}/>
              }
            >
              {getFieldDecorator("title", {
                initialValue: this.state.title,
                rules: [
                  {
                    whitespace: true,
                    required: true,
                    message: (
                      <FormattedMessage
                        id="app.title_is_required"
                        defaultMessage={`Title is required!`}
                      />
                    )
                  }
                ]
              })(<Input/>)}
            </Form.Item>
          </Col>
          <Col span={9}>
            <Form.Item
              label={<FormattedMessage id="app.url" defaultMessage={`URL`}/>}
            >
              {getFieldDecorator("url", {
                initialValue: this.state.url,
                rules: [{
                  whitespace: true,
                  required: true,
                  message: (
                    <FormattedMessage
                      id="app.url_is_required"
                      defaultMessage={`URL is required!`}
                    />
                  )
                }]
              })(
                <Select>
                  {AppRoutes.map(route => (
                    <Option key={route.key} value={route.key}>
                      <div>
                        {/*<span className={'menu-url-option-path'}> {`(${route.path})`} </span>*/}
                        <span>
                          {route.label}
                        </span>
                      </div>
                    </Option>
                  ))}
                </Select>
              )}
            </Form.Item>
          </Col>
          {/*<Col span={12}>*/}
            {/*<Form.Item*/}
              {/*label={*/}
                {/*<FormattedMessage*/}
                  {/*id="app.parent_menu"*/}
                  {/*defaultMessage={`Parent Menu`}*/}
                {/*/>*/}
              {/*}*/}
            {/*>*/}
              {/*{getFieldDecorator("parent", {*/}
                {/*initialValue: this.state.parent ? this.state.parent : null*/}
              {/*})(*/}
                {/*<MenuSingleSelection*/}
                  {/*mode={SelectionMode.DEFAULT}*/}
                  {/*selectedMenu={this.state.parent}*/}
                  {/*onChange={this.onChangeParent}*/}
                {/*/>*/}
              {/*)}*/}
            {/*</Form.Item>*/}
          {/*</Col>*/}
          <Col span={6}>
            <Form.Item
              label={
                <FormattedMessage id="app.status" defaultMessage={`Status`}/>
              }
            >
              <Switch
                defaultChecked={this.state.is_active}
                onChange={this.onStatusChange.bind(this)}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    );
  }
}

const WrappedMenuForm = Form.create({name: "menu-form"})(MenuForm);
export default withFormWrapper(WrappedMenuForm);
